export * from './WeeklyResultsIndicator'
export * from './WeeklyResultsIndicator.types';